import ModalController from "../modal_controller"
import { template } from "lodash"
import { saveFile } from "../helpers"

export default class extends ModalController {
  static targets = [...ModalController.targets, "modalTemplate", "content", "errors", "errorsList", "exportButton", "exportUpoButton",
    "sendButton", "messages", "infoAlertTemplate", "warningAlertTemplate", "errorAlertTemplate", "successAlertTemplate"]

  static values = {
    statusMap: Object,
    validStatus: { type: String, default: "ok" },
    offlineStatus: { type: String, default: "offline" },
    offlineErrorStatus: { type: String, default: "offline_error" },
    kind: { type: String, default: "ksef" },
    needsAuthorizationMessage: { type: String, default: "" }
  }

  errorOrWarning
  warningTemplates = {}
  baseStatus
  govXmlUrl
  govUpoXmlUrl

  connect() {
    super.connect()
    if (this.hasModalTemplateTarget) {
      this.resourceTemplate = template(this.modalTemplateTarget.innerHTML)
    }

    if (this.hasInfoAlertTemplateTarget) {
      this.warningTemplates.info = template(this.infoAlertTemplateTarget.innerHTML)
    }

    if (this.hasWarningAlertTemplateTarget) {
      this.warningTemplates.warning = template(this.warningAlertTemplateTarget.innerHTML)
    }

    if (this.hasErrorAlertTemplateTarget) {
      this.warningTemplates.error = template(this.errorAlertTemplateTarget.innerHTML)
    }

    if (this.hasSuccessAlertTemplateTarget) {
      this.warningTemplates.success = template(this.successAlertTemplateTarget.innerHTML)
    }
  }

  open(event) {
    super.open()
    const invoiceGovData = JSON.parse(event.currentTarget.dataset.invoice)

    this.contentTarget.innerHTML = this.resourceTemplate({
      ...invoiceGovData,
      ...this.prepareStatus(invoiceGovData)
    })

    this.setErrorMessages(invoiceGovData)

    if (this.kindValue === "ksef") {
      this.setExportKsef(invoiceGovData)
      this.showButtons(invoiceGovData)
    }
  }

  prepareStatus(govData) {
    switch (this.kindValue) {
      case "verifactu": {
        const taxAgencyStatus = govData.plain_verifactu_status === "send_error" && govData.plain_tax_agency_status === null ? "not_sent" : govData.plain_tax_agency_status
        return {
          status_icon: this.statusMapValue[govData.plain_verifactu_status] || govData.verifactu_status,
          tax_agency_status_icon: this.statusMapValue[taxAgencyStatus] || govData.tax_agency_status
        }
      }
      case "ksef":
        this.baseStatus = govData.ksef_status && govData.ksef_status.startsWith("demo_") ? govData.ksef_status.substring(5) : govData.ksef_status
        return {
          status_info: this.statusMapValue[govData.ksef_status] || "Nieznany status",
        }
      default:
        throw new Error(`unknown giv kind: ${this.kindValue}`)
    }
  }

  setErrorMessages(govData) {
    const errors = this.kindValue === "verifactu" ? govData.verifactu_errors : govData.ksef_errors
    if (!errors) return

    errors.forEach((obj) => {
      const liElement = document.createElement("li")
      liElement.innerHTML = obj
      this.errorsListTarget.appendChild(liElement)
    })
    this.errorsTarget.classList.remove("hidden")
  }

  showButtons(govData) {
    if (!this.hasSendButtonTarget || !govData.can_resend) return

    const permission = govData.gov_permission
    if (permission === "can_send") {
      this.sendButtonTarget.classList.remove("hidden")
      this.sendButtonTarget.disabled = false
    } else if (permission === "needs_authorization") {
      this.sendButtonTarget.classList.remove("hidden")
      this.sendButtonTarget.disabled = true
      if (this.needsAuthorizationMessageValue) {
        this.sendButtonTarget.title = this.needsAuthorizationMessageValue
      }
    }
    // not_allowed / null → przycisk ukryty (domyślnie)
  }

  setExportKsef(data) {
    const date = new Date(data.gov_sell_date)
    date.setHours(date.getHours() + 3)
    this.errorOrWarning = isNaN(date.getTime()) ? "error" : (date > new Date() ? "warning" : "error")
    this.govXmlUrl = data.gov_xml_url
    this.govUpoXmlUrl = data.gov_upo_xml_url

    if (!data.ksef_id || this.baseStatus !== this.validStatusValue) {
      this.exportButtonTarget.disabled = true
    } else {
      this.exportButtonTarget.disabled = false
    }

    if (!data.ksef_id || this.baseStatus !== this.validStatusValue || !data.upo) {
      this.exportUpoButtonTarget.disabled = true
    } else {
      this.exportUpoButtonTarget.disabled = false
    }
    this.showMessage(null)
  }

  exportXMLFile(event) {
    event.preventDefault()
    event.stopPropagation()

    const xmlUrl = event.params.type === "invoice" ? this.govXmlUrl : this.govUpoXmlUrl
    if (!xmlUrl) {
      this.showMessage(this.errorOrWarning)
      return
    }

    this.showMessage("info")
    fetch(xmlUrl)
      .then(response => response.ok ? response.blob() : this.showMessage(this.errorOrWarning))
      .then(blob => {
        if (blob) {
          saveFile(`${event.params.type}-${event.params.ksefId}.xml`, null, blob)
          this.showMessage("success")
        }
      }).catch((_err) => this.showMessage("error"))
  }

  sendToKsef(event) {
    const id = event.params.id

    if (!id) {
      console.error("Brak ID")
      return
    }

    this.showMessage("info")
    fetch(`/invoices/${event.params.id}?send_to_ksef=yes`)
      .then(() => window.location.reload())
  }

  showMessage(type) {
    this.messagesTarget.innerHTML = ""
    if (this.hasMessagesTarget && type) {
      const msg = this.warningTemplates[type] || this.warningTemplates.info
      this.messagesTarget.innerHTML = msg()
    }
  }
}
